import {
  BarChartData,
  BarChartLayout,
  BarChartLegend,
} from "Components/Chart/BarChart/barChartInterface";
import {
  isAkaCriticalIllnessInsuredSelected,
  isCriticalIllnessInsuranceSelected,
} from "Store/akaAdvice/mappers/mapToCartProducts/mapToCartProducts";

import { getChartSize } from "Components/Chart/chartConfig";
import { VALUE_TYPE } from "Components/NumberValue";
import { getPriceFormatFromValue } from "Formatting/index";
import { WindowSize } from "Utils/screenSizeUtils";
import { FormikProps } from "formik";
import { AkaAdvicePriceFormValues } from "../../interfaces";

export const getCriticalIllnessChartData = (
  salary: number,
  formProps: FormikProps<AkaAdvicePriceFormValues>,
  baseAmount: number,
): BarChartData[] => {
  const {
    akaCriticalIllnessCoverageAmountGLevel,
    criticalIllnessInsuredSumSlider,
  } = formProps.values;
  const akaOneTimePayment = isAkaCriticalIllnessInsuredSelected(
    formProps.values,
  )
    ? Number(akaCriticalIllnessCoverageAmountGLevel) * baseAmount
    : 0;
  const oneTimePayment = isCriticalIllnessInsuranceSelected(formProps.values)
    ? criticalIllnessInsuredSumSlider ?? 0
    : 0;

  const xAxisCoordinates = ["Årslønn i dag", "Engangsutbetaling"];

  const data = [
    {
      x: xAxisCoordinates,
      y: [salary, 0],
      hovertemplate: [getPriceFormatFromValue(salary, VALUE_TYPE.NOK), ""],
      width: 0.4,
      name: "Årslønn i dag",
      marker: {
        color: "#C7AA7F",
      },
    },
  ];
  if (akaOneTimePayment > 0) {
    data.push({
      x: xAxisCoordinates,
      y: [0, akaOneTimePayment],
      width: 0.4,
      hovertemplate: [
        "",
        getPriceFormatFromValue(akaOneTimePayment, VALUE_TYPE.NOK),
      ],
      name: "A+ Kritisk sykdom",
      marker: {
        color: "#0191A5",
      },
    });
  }
  if (oneTimePayment > 0) {
    data.push({
      x: xAxisCoordinates,
      y: [0, oneTimePayment],
      width: 0.4,
      hovertemplate: [
        "",
        getPriceFormatFromValue(oneTimePayment, VALUE_TYPE.NOK),
      ],
      name: "Individuell kritisk sykdom",
      marker: {
        color: "#D2F5F9",
      },
    });
  }
  return data;
};

export const getCriticalIllnessChartLayout = (
  windowSize: WindowSize,
): BarChartLayout => ({
  title: "",
  size: getChartSize(windowSize),
  xAxis: { type: "category" },
  yAxis: { nticks: 5, showline: true, showgrid: false },
  legend,
});

const legend: BarChartLegend = {
  orientation: "h",
  y: -0.3,
};
